import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { TranslateModule } from '@ngx-translate/core';

import {
    HeaderTopbarSm2024Component,
} from '@shared/header/layouts/header-topbar-sm-2024/header-topbar-sm-2024.component';
import { HeaderMenuComponent } from '@shared/header-menu/components/header-menu/header-menu.component';
import {
    HeaderMenuCategoryComponent,
} from '@shared/header-menu/components/header-menu-category/header-menu-category.component';
import {
    HeaderMenuSubcategoryComponent,
} from '@shared/header-menu/components/header-menu-subcategory/header-menu-subcategory.component';
import { HeaderSearchComponent } from '@shared/header-menu/components/header-search/header-search.component';
import { HeaderItemTitlePipe } from '@shared/header-menu/pipes/header-item-title.pipe';

@NgModule({
    declarations: [
        HeaderItemTitlePipe,
        HeaderMenuCategoryComponent,
        HeaderMenuComponent,
        HeaderMenuSubcategoryComponent,
        HeaderSearchComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        HeaderTopbarSm2024Component,
        MdIconComponent,
    ],
    exports: [
        HeaderMenuComponent,
    ],
})
export class HeaderMenuModule {
    public get HeaderMenuComponent() {
        return HeaderMenuComponent;
    }
}
